<template>
    <div class="position-relative has-tool-menu">
        <div class="tool-menu">
            <Breadcrumb />

            <div class="buttons">
                <ButtonAreas :entities="selected" />

                <b-button variant="primary" :disabled="loading" @click="fetchProducts">
                    <span :class="{ fa: true, 'fa-download': !loading, 'fa-sync': loading, 'fa-spin': loading }"></span>
                    <span v-if="loading">Henter produkter {{syncDone}}</span>
                    <span v-else>Hent produkter</span>
                </b-button>
            </div>
        </div>

        <b-card no-body>
            <div slot="header">
                <i class="fa fa-user-tie"></i> Produkter
                <div class="card-header-actions"></div>
            </div>
            <DataTable ref="dataTable" v-if="fields" url="/api/module/mrbeef-lager/products" :fields="fields" name="products" :filter="true" @row-click="rowClick" cache-search="mrbeef-lager">
                <template slot="name" slot-scope="{props}">
                    <b-link :to="'/products/' + props.row.Id">
                        {{props.row.name}}
                    </b-link>
                </template>

                <template slot="5e2c6b1f329b745cdca400bb" slot-scope="{props}">
                    <span v-if="props.row['5e2c6b1f329b745cdca400bb'] && props.row['5e2c6b09329b745cdca400b6'] == 'Ja'">
                        {{$moment(props.row['5e2c6b1f329b745cdca400bb']).format("DD-MM-YYYY")}}
                    </span>
                </template>

                <template slot="65fb79e6cd239776f7faa407" slot-scope="{props}">
                    <span v-if="props.row['65fb79e6cd239776f7faa407'] && props.row['65fb79a9cd239776f7faa3fe'] == 'Ja'">
                        {{$moment(props.row['65fb79e6cd239776f7faa407']).format("DD-MM-YYYY")}}
                    </span>
                </template>

                <template slot="CreateDate" slot-scope="{props}">
                    {{$moment(props.row.CreateDate).format("DD-MM-YYYY HH:mm")}}
                </template>

                <template slot="edit" slot-scope="{props}">
                    <b-button variant="success" @click.stop="stockIn(props.row)"><i class="fa fa-sign-in-alt"></i> Lager ind</b-button>
                    <b-button variant="danger" @click.stop="stockOut(props.row)"><i class="fa fa-sign-out-alt"></i> Lager ud</b-button>
                </template>
            </DataTable>
        </b-card>
    </div>
</template>

<script>
    import lagerScanning from './modals/lagerScanning';

    export default {
        data: () => ({
            fields: [
                {
                    "name": "productId",
                    "type": "number",
                    "label": "Produkt Id",
                    "value": null,
                    "filter": true,
                    "visible": true,
                    "sort": true,
                    "class": null,
                    "values": []
                },
                {
                    label: "Navn",
                    name: "name",
                    filter: true,
                    type: "text",
                    sort: true,
                    class: null,
                    value: null,
                    visible: true
                },
                {
                    label: "Navn 2",
                    name: "name2",
                    filter: true,
                    type: "text",
                    sort: true,
                    class: null,
                    value: null,
                    visible: true
                },
                {
                    label: "Producent",
                    name: "brand",
                    filter: true,
                    type: "text",
                    sort: true,
                    class: null,
                    value: null,
                    visible: true
                },
                {
                    label: "Lagerstatus",
                    name: "stock",
                    filter: false,
                    type: "number",
                    sort: true,
                    class: null,
                    value: null,
                    visible: true
                },

                {

                    "name": "type",
                    "type": "select",
                    "label": "Type",
                    "value": null,
                    "filter": true,
                    "visible": true,
                    "sort": false,
                    "class": null,
                    "values": [
                        "normal",
                        "packet",
                        "discontinued"
                    ]
                },
                {
                    label: "0°C køleprodukt",
                    name: "5e2c6b1f329b745cdca400bb",
                    filter: true,
                    type: "date",
                    sort: true,
                    class: null,
                    value: null,
                    visible: true
                },
                {
                    label: "5°C køleprodukt",
                    name: "67c13e639b2bab44b8272bef",
                    filter: true,
                    type: "date",
                    sort: true,
                    class: null,
                    value: null,
                    visible: true
                },
                {
                    label: "Frostprodukt",
                    name: "67c13e879b2bab44b8272bfa",
                    filter: true,
                    type: "date",
                    sort: true,
                    class: null,
                    value: null,
                    visible: true
                },
                {
                    label: "Tørvare",
                    name: "689389249f68823fc10774a5",
                    filter: true,
                    type: "date",
                    sort: true,
                    class: null,
                    value: null,
                    visible: true
                },

                {
                    label: "Action",
                    name: "65fb79e6cd239776f7faa407",
                    filter: true,
                    type: "date",
                    sort: true,
                    class: null,
                    value: null,
                    visible: true
                },
                {
                    label: "Intern",
                    name: "68938bed9f68823fc1077724",
                    filter: true,
                    type: "date",
                    sort: true,
                    class: null,
                    value: null,
                    visible: true
                },
                {
                    label: "Created",
                    name: "CreateDate",
                    filter: true,
                    type: "date",
                    sort: true,
                    class: null,
                    value: null,
                    visible: false
                },
                {
                    name: "edit",
                    visible: true,
                    label: "",
                    class: "text-right",
                }
            ],
            selected: [],
            loading: false,
            syncDone: 0
        }),
        components: {},
        computed: {},
        methods: {
            rowClick(e) {
                if (e.length > 0) {
                    //this.selected.push(e[0].Id);
                }
            },
            // Henter produkterne i portioner. Serveren tager én portion pr. kald, så vi bliver
            // ved med at poste med stigende skip indtil svaret melder at der ikke er flere.
            async fetchProducts() {
                this.loading = true
                this.syncDone = 0

                var take = 25
                var skip = 0
                var synced = 0
                var errors = []
                var syncTicks = 0

                try {
                    while (true) {
                        var x = await this.$http.post("/api/module/mrbeef-lager/sync-products-batch?skip=" + skip + "&take=" + take + "&syncTicks=" + syncTicks + "&failed=" + (errors.length > 0))

                        syncTicks = x.data.syncTicks
                        synced += x.data.synced
                        errors = errors.concat(x.data.errors || [])

                        skip += take
                        this.syncDone = synced

                        if (x.data.done) {
                            break
                        }
                    }

                    var message = synced + " produkter blev hentet."
                    if (errors.length > 0) {
                        message += "\n\n" + errors.length + " produkter fejlede:\n" + errors.slice(0, 20).join("\n")
                    }

                    alert(message)

                    this.$refs.dataTable.refresh()
                } catch (e) {
                    alert("Hentningen blev afbrudt: " + e)
                }

                this.loading = false
            },
            stockIn(product) {
                this.$dialog.open(lagerScanning, {}, {
                    title: product.name + " " + product.brand,
                    hideFooter: true,
                    noClose: true,
                    onClose: () => {
                        this.$refs.dataTable.refresh();
                    },
                    props: { productId: product.Id, stockIn: true }
                })
            },
            stockOut(product) {
                this.$dialog.open(lagerScanning, {}, {
                    title: product.name + " " + product.brand,
                    hideFooter: true,
                    noClose: true,
                    onClose: () => {
                        this.$refs.dataTable.refresh();
                    },
                    props: { productId: product.Id, stockIn: false }
                })
            }
        },
        created() {
        },
        mounted() { }
    };
</script>